import { Pipe, PipeTransform } from '@angular/core';
import { Action } from '../signs/sign.service';

@Pipe({
  name: 'prettyActionName',
})
export class PrettyActionNamePipe implements PipeTransform {
  transform(action: Action | string): string {
    switch (action) {
      case Action.erect:
      case 'E':
        return 'Erect';
      case Action.reerect:
      case 'R':
        return 'Re-erect';
      case Action.change:
      case 'C':
        return 'Change';
      case Action.collect:
      case 'COL':
        return 'Collect';
      case Action.stray:
      case 'STR':
        return 'Stray';
      default:
        return 'ERROR';
    }
  }
}
